export default __webpack_public_path__ + "static/media/click.5711c873.mp3";